export default __webpack_public_path__ + "static/media/agent_img_about.78bfebf5.gif";